async function StateSave (stateid, statename, stateabbr, modifiedbyid, deleted, countryid) {

    if (
        statename.length > 0 && 
        stateabbr.length > 0 && 
        modifiedbyid.length > 0 && 
        deleted.length > 0 && 
        countryid.length > 0
    ) {

            let response;

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "57", 
                    "parameters": {
                        "@StateId": stateid,
                        "@StateName": statename,
                        "@StateAbbr": stateabbr,
                        "@ModifiedById": modifiedbyid,
                        "@Deleted": deleted,
                        "@CountryId": countryid
                    },
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .then((data) => {
                if (JSON.parse(data.payload).error.length > 0) {            
                    throw Error(JSON.parse(data.payload).error);
                }
                else {
                    response = JSON.parse(data.payload).data; 
                }
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return response;

    }
}
 
export default StateSave;